import * as Styled from './styles'

interface Props {
  videoUrl: string
}
export const VideoContainer = ({ videoUrl }: Props) => {
  return <Styled.VideoPlayer src={videoUrl} />
}
